import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { Button, Col, Form, Row } from 'antd';
import { createIsRequestedSelector, createSonarSelector } from '@lib/selectors';
import { FirstName, LastName } from '@ui/form-items';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';
const patchUserStateSelector = createSonarSelector((state) => state.core.users.current.patch);
const isUserUpdatingSelector = createIsRequestedSelector(patchUserStateSelector);
const buttonText = `${COPY_SPECIFIC.UPDATE} ${COPY_SPECIFIC.NAME}`;
export const AccountInformation = () => {
    const { firstName, lastName, id } = useCurrentUser();
    const isUserUpdating = useSonarSelector(isUserUpdatingSelector);
    const updateUser = useAction(coreActions.requestPatchCoreUsersCurrent);
    const handleFinish = useCallback((userUpdateOptions) => {
        if (!id) {
            return;
        }
        updateUser(Object.assign(Object.assign({}, userUpdateOptions), { userId: id }));
    }, [id, updateUser]);
    return (React.createElement("div", { id: 'account-information' },
        React.createElement(Form, { initialValues: {
                firstName,
                lastName
            }, layout: 'vertical', name: 'account-information', onFinish: handleFinish, requiredMark: false },
            React.createElement(Row, { gutter: 16 },
                React.createElement(Col, { span: 12 },
                    React.createElement(FirstName, { disabled: false, id: 'user-first-name', label: COPY_SPECIFIC.FIRST_NAME })),
                React.createElement(Col, { span: 12 },
                    React.createElement(LastName, { disabled: false, id: 'user-last-name', label: COPY_SPECIFIC.LAST_NAME }))),
            React.createElement(Button, { disabled: isUserUpdating, htmlType: 'submit', id: 'update-user-name-submit-button', type: 'primary' }, buttonText))));
};
